// extracted by mini-css-extract-plugin
export default {"fill-placeholder-child":"fill-placeholder-child_9Pt6G","after-pay-steps":"after-pay-steps_5ubmh","step":"step_roXWO","text":"text_ZwxbN"};